import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';

import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { PqqSectionsComponent } from '../pqq-sections.component';

@Component({
  selector: 'app-work-packages',
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './work-packages.component.html',
  styleUrl: './work-packages.component.css',
})
export class WorkPackagesComponent implements OnInit {
  selectedWorkPackages: any[] = []; // Initialize as an empty array
  projectIdNew: string;
  pqqData: any;
  selectAllChecked = false; // To track the "Select All" checkbox state
  projectName: string;
  isEdit = false;
  submittedWorkPackages: any;
  submittedData: any;

  constructor(
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private GetProjectIdService: GetProjectIdService,
    private PqqSectionsComponent: PqqSectionsComponent,
    private projectsService: ProjectsService
  ) {}

  private subscription: Subscription = new Subscription();

  pqqTitle = new FormControl('', Validators.required);  
  w_p_description = new FormControl();

  ngOnInit(): void {
    this.projectName = localStorage.getItem('project-name');
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });
    if (this.isEdit) {
      this.fetchDataForPqq();
    }

    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.fetchDataForPqq();
    });
  }

  toggleWorkPackageSelection(event: Event, workpackage: any): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedWorkPackages.push({
        id: workpackage?.id,
        name: workpackage?.work_package?.name,
      });
    } else {
      this.selectedWorkPackages = this.selectedWorkPackages.filter(
        (wp: any) => wp?.id !== workpackage?.id
      );
    }
  }

  isSelected(id: number): boolean {
    return this.selectedWorkPackages.some((wp: any) => wp?.id === id);
  }

  selectAllWorkPackages(): void {
    if (!this.selectAllChecked) {
      // If "Select All" is checked, add all work packages to selected list
      this.selectAllChecked = !this.selectAllChecked;
      this.selectedWorkPackages =
        this.pqqData?.projectWPDetails?.map((workpackage: any) => ({
          id: workpackage?.id,
          name: workpackage?.work_package?.name,
        })) || [];
    } else {
      // If "Select All" is unchecked, clear the selected work packages list
      this.selectAllChecked = !this.selectAllChecked;
      this.selectedWorkPackages = [];
    }
  }

  fetchDataForPqq() {
    this.TenderingService.getInitiatiationData().subscribe({
      next: (response: any) => {
        this.pqqData = response.data;
        if (this.isEdit) {
          this.submittedInitiationData();
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch PQQ initiation data:', error);
      },
    });
  }

  submittedInitiationData(): any {
    return this.projectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.submittedWorkPackages = response?.data?.selected_work_packages;
        this.submittedData = response?.data;

        // Preselect submitted work packages
        this.selectedWorkPackages =
          this.pqqData?.projectWPDetails
            ?.filter((workpackage: any) =>
              this.submittedWorkPackages.some(
                (submittedWP: any) =>
                  submittedWP?.name === workpackage?.work_package?.name
              )
            )
            ?.map((wp: any) => ({
              id: wp?.id,
              name: wp?.work_package?.name,
            })) || [];

        this.pqqTitle.setValue(this.submittedData?.title);
        this.w_p_description.setValue(this.submittedData?.work_packages_des);
      },
      error: (error) => {
        console.error('Error fetching record of Work Packages:', error);
      },
    });
  }

  moveToPreviousStep() {
    this.PqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const pwpData = this.selectedWorkPackages;
    const data = {
      ...(this.isEdit && { pqq_id: this.submittedData.id ?? null }),
      pqq_name: this.pqqTitle.value,
      title: this.pqqTitle.value,
      work_packages_des: this.w_p_description.value,
      p_w_p: pwpData,
    };

    return data;
  }

  moveToNextStep() {
    const dataToSubmit = this.prepareDataToSubmit();

    this.projectsService.projectPQQInitiateStep2(dataToSubmit).subscribe({
      next: (response: any) => {
        this.toast.success('Work Packages Submitted submitted', 'SUCCESS');
        const pqqId = response?.data[0]?.id;
        this.TenderingService.setpqqId(pqqId);
        this.PqqSectionsComponent.nextStep();
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  handleBack() {
    this.PqqSectionsComponent.previousStep();
  }
}
